import {Prop} from 'vue-property-decorator';
import Button from "../Button";

/** Classe contenant les propriétés spécifiques aux boutons n'étant composés que d'une icône */
export default class ButtonIcon extends Button {
    /** Facultatif : ButtonInsideClass personnalisé */
    @Prop({default: () => ""})
    public ButtonInsideClass!: string | string[];

    /** Facultatif : Class attaché à l'icône pour des besoins de debug */
    @Prop({default: () => ""})
    public IconClass!: string | string[];

    /** Facultatif : Class attaché à l'icône pour des besoins de debug */
    @Prop({default: () => ""})
    public ContentClass!: string | string[];

    /** Facultatif : Permet d'indiquer si le bouton est en Outline ou pas (par défaut 'vrai') */
    @Prop({default: () => true})
    public Outline!: boolean;
}